import { gsap } from "gsap";
import horizontalLoop from "../js_modules/_horizontal-loop.mjs";
import initTestimonialSlider from "../js_modules/_testimonial-slider.mjs";

import expertiseShader from "../js_modules/_expertise-shader.mjs";
import homeEditorial from "../js_modules/_home-editorial.mjs";
import initServiceFourHero from "../js_modules/_service-four-hero.mjs";

const scrolling_projects = gsap.utils.toArray(
  ".service-four-hero__scrolling-project",
);

import { createShader } from "shaders/js";

horizontalLoop(scrolling_projects, { speed: 0.8, repeat: -1 });

const goto_buttons = document.querySelectorAll(".go-to");

if (goto_buttons && goto_buttons.length > 0) {
  goto_buttons.forEach((button) => {
    const target = button.getAttribute("href");
    button.addEventListener("click", (e) => {
      e.preventDefault();
      gsap.to(window, { scrollTo: { y: target, offsetY: 50 }, duration: 1 });
    });
  });
}

initTestimonialSlider();

const faq_questions = document.querySelectorAll(".faq-questions__question");

if (faq_questions) {
  faq_questions.forEach((question) => {
    const trigger = question.querySelector(".faq-questions__question-top");
    const answer_outer = question.querySelector(
      ".faq-questions__question-answer-outer",
    );
    if (trigger) {
      trigger.addEventListener("click", () => {
        if (!trigger.classList.contains("open")) {
          trigger.classList.add("open");
          if (answer_outer) {
            gsap.to(answer_outer, { height: "auto", duration: 0.5 });
          }
        } else {
          trigger.classList.remove("open");
          if (answer_outer) {
            gsap.to(answer_outer, { height: 0, duration: 0.5 });
          }
        }
      });
    }
  });
}

expertiseShader();
homeEditorial();
initServiceFourHero();
